export const STORE_KEY = '__CONFIG_DETAILS__';
export const INITIAL_STATE = {
    cities: [],
    campaignOpDisabled: false,
    campaignOpDisabledCallout: 'Campaign operations are disabled',
};
